import { useCallback } from 'react'
import {
  createAICommand,
  AICommandType,
  createNodeCommandPayload,
  useAICommandState
} from '@/utils/aiCommandUtils'
import { QuickStartNodeData } from '../types'

const QUICKSTART_COMMAND_TYPE = 'QuickStartCommand-Process'

export function useQuickStartProcessing(
  id: string,
  data: QuickStartNodeData,
  syncNodeData: (newData: Partial<QuickStartNodeData>) => void
) {  // AI command state
  const aiCommandState = useAICommandState(
    data.documentRequest,
    AICommandType.QUICKSTART_COMMAND || 'QuickStartCommand-Process' as any
  )

  const handleProcessClick = useCallback(() => {
    if (!data.challenge?.trim() || !data.desiredOutcome?.trim()) {
      const errorMsg = 'Error: Both challenge and desired outcome are required.'
      syncNodeData({ statusMessage: errorMsg })
      return
    }

    const processingMsg = 'Processing triggered.'
    syncNodeData({ statusMessage: processingMsg })    // Use enum with fallback to hardcoded string
    const commandType = AICommandType.QUICKSTART_COMMAND || 'QuickStartCommand-Process'
    const documentRequest = createAICommand(
      commandType as any,
      createNodeCommandPayload(id, {
        challenge: data.challenge,
        desiredOutcome: data.desiredOutcome,
        document: 'sam-default',
      })
    ) as QuickStartNodeData['documentRequest']



    syncNodeData({ documentRequest })
  }, [id, data.challenge, data.desiredOutcome, syncNodeData])

  const canProcess = Boolean(
    data.challenge?.trim() &&
    data.desiredOutcome?.trim() &&
    !aiCommandState.isProcessing
  )

  return {
    ...aiCommandState,
    handleProcessClick,
    canProcess,
  }
}
